import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UpdateCurrentLine } from '../../store/features/line';

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
  </Box>
);

export default function LinePiece(props) {
  const dispatch = useDispatch();
  const clickHandler = () => {
    console.log(props.data);
    dispatch(UpdateCurrentLine(props.data));
  }
  const storageURL = process.env.REACT_APP_Stroage_URL;

  return (
    props.data && <Card sx={{ minWidth: 75, boxShadow: "none" }} onClick={clickHandler}>
      <Link to="/linedetail">
        <CardContent sx={{ padding: 0, }}>
          {/* <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Word of the Day
        </Typography>
        <Typography variant="h5" component="div">
          be{bull}nev{bull}o{bull}lent
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          adjective
        </Typography>
        <Typography variant="body2">
          well meaning and kindly.
          <br />
          {'"a benevolent smile"'}
        </Typography> */}
          <img src={storageURL + props.data.nav_img} loading="lazy"></img>
        </CardContent>
        <CardActions sx={{ display: 'flex', flexWrap: 'wrap', margin: 0 }}>
          <Stack spacing={1} direction="row" sx={{ width: '100%' }}>
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
              {props.data.name}
            </Typography>
          </Stack>
          {/* 
          <Stack spacing={1} direction="row" justifyContent="flex-start" style={{ marginLeft: 0 }}>
            <Rating size="small" name="half-rating-read" defaultValue={Number((5 * props.data.score / 100).toFixed(1))} precision={0.1} readOnly />
            <Typography sx={{ fontSize: 14 }} color="text.secondary">
              {(5 * props.data.score / 100).toFixed(1)}
            </Typography>
          </Stack> */}
        </CardActions>
      </Link>
    </Card>
  );
}